<div cf-loader-container>
  <main [@fadeInOnEnter]>
    <div class="my-auto">
      <header class="text-center">
        <cf-text class="mt-2" size="lg" weight="600"> {{ "booking_auth.login.title" | translate }} </cf-text>
        <div class="d-flex justify-content-center flex-wrap gap-3 mt-3">
          <cf-google-auth
            class="flex-grow-1"
            [buttonName]="'booking_auth.login.with_google' | translate"
            [isLogin]="true"
          ></cf-google-auth>

          <cf-microsoft-auth class="flex-grow-1" [invitationEmail]="email" [redirectUriKey]="'booking_redirect_uri'">
            {{ "auth.sign_in_microsoft" | translate }}
          </cf-microsoft-auth>
        </div>
      </header>

      <section class="mt-4 mb-4">
        <div class="form-separator mb-2">
          <cf-text color="grey-40" size="xl" touchSize="md">{{ "booking_auth.login.or" | translate }}</cf-text>
        </div>

        <form [formGroup]="loginForm">
          <cf-form-field>
            <cf-input-label size="lg" required>
              {{ "auth.email" | translate }}
            </cf-input-label>
            <!-- <cf-icon icon="mail" cf-input-prefix></cf-icon> -->
            <span cf-input-prefix>
              <svg cfIcon="mail" class="tw:text-gray-40"></svg>
            </span>
            <input cf-input class="size--lg" formControlName="email" name="email" type="text" />
            <cf-input-error message="{{ 'validation.enter_valid_email' | translate }}"></cf-input-error>
          </cf-form-field>

          <div class="mt-4">
            <cf-password-input labelSize="lg" #passInput formControlName="password"></cf-password-input>
          </div>
          <a class="w-100 mt-2 text-end" cf-link [underlined]="false" (click)="forgotPasswordRedirect()">
            {{ "auth.forgot_password" | translate }}
          </a>

          <cf-text color="red-60" size="sm" weight="400" class="mt-4 w-100 text-center" *ngIf="showErrorMsg">
            {{ "validation.password_is_not_right" | translate }}
          </cf-text>
          <div class="mt-4 w-100">
            <cf-button isLoadingBtn disableOnRequest class="w-100" className="w-100" size="lg" (click)="login()">
              {{ "auth.login" | translate }}
            </cf-button>
          </div>
        </form>
      </section>
    </div>
  </main>
</div>
